import { render, staticRenderFns } from "./MigrateMenu.vue?vue&type=template&id=50f0f449&scoped=true&"
import script from "./MigrateMenu.vue?vue&type=script&lang=js&"
export * from "./MigrateMenu.vue?vue&type=script&lang=js&"
import style0 from "./MigrateMenu.vue?vue&type=style&index=0&id=50f0f449&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f0f449",
  null
  
)

export default component.exports